// extracted by mini-css-extract-plugin
export default {"image":"ThumbsDownButton_image__BEuN8","active":"ThumbsDownButton_active__fjzhv"};